import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Clear from "@material-ui/icons/Clear";
import IconButton from "@material-ui/core/IconButton";

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);  
  return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,  

  // change background colour if dragging
  background: isDragging ? "lightgreen" : '#fff',

  // styles we need to apply on draggables
  ...draggableStyle
});

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "lightgrey",
  padding: grid,
  width: '99%'
});

class ListSimple extends Component {

  constructor(props) {
    super(props);
    this.state = {
      items: props.datasets,
    };
    this.onDragEnd = this.onDragEnd.bind(this);    
  }

  componentDidUpdate(prevProps, next) {  
    if(this.props.datasets !== prevProps.datasets) {
      this.setState({items: this.props.datasets})
    }
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({
      items
    });

    this.props.onEventChange(items.map((item, index) => { return {position:index, id: item.id}}))

  }

  handleRemove = (id) =>{
    this.props.eventRemove(id);
  }

  // Normally you would want to split things out into separate components.
  // But in this example everything is just done in one place for simplicity
  render() {
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {this.state.items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                      )}
                    >
                      [{index}] -
                      <IconButton color="primary"
                                  title="Remover item da lista"
                                  value={item.id}
                                  onClick={()=>this.handleRemove(item.id)} ><Clear /></IconButton>
                      |
                        {item.description}
                        {item.out} - {item.chartType?item.chartType:''} - ID: <i>{item.id}</i>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}


export default ListSimple